var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.654,
    height: 12.654,
    viewBox: "0 0 12.654 12.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    d: "M11.75,7.221H7.683V3.154a.9.9,0,0,0-.9-.9h-.9a.9.9,0,0,0-.9.9V7.221H.9a.9.9,0,0,0-.9.9v.9a.9.9,0,0,0,.9.9H4.971V14a.9.9,0,0,0,.9.9h.9a.9.9,0,0,0,.9-.9V9.933H11.75a.9.9,0,0,0,.9-.9v-.9A.9.9,0,0,0,11.75,7.221Z",
    transform: "translate(0 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.f4e4be2e9156ecd9f80297220a2e0fd1.svg";
export { ForwardRef as ReactComponent };